// ═══════════════════════════════════════════════════════════════
// COMPONENTES REUTILIZABLES para acciones admin con contraseña
// ═══════════════════════════════════════════════════════════════

import React, { useState } from 'react';
import api from '../utils/api';
import { XCircle, Trash2, AlertCircle, CheckCircle2 } from 'lucide-react';

// ───────────────────────────────────────────────────────────────
// MODAL: Eliminar registro con contraseña
// Props: endpoint, descripcion (string a mostrar), onClose, onEliminado
// ───────────────────────────────────────────────────────────────
export function ModalEliminarRegistro({ endpoint, descripcion, onClose, onEliminado }) {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleEliminar = async () => {
    if (!password) { setError('Debes introducir tu contraseña'); return; }
    setLoading(true); setError('');
    try {
      await api.delete(endpoint, { data: { password } });
      onEliminado();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al eliminar');
    } finally { setLoading(false); }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2 style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--color-danger)' }}>
            <Trash2 size={20} /> Eliminar Registro
          </h2>
          <button className="btn btn-ghost btn-icon" onClick={onClose}><XCircle size={18} /></button>
        </div>
        <div className="modal-body">
          <div className="alert alert-danger"><AlertCircle size={16} /> <strong>Esta acción no se puede deshacer.</strong></div>
          
          {descripcion && (
            <div style={{ padding: 12, background: 'var(--color-gray-1)', borderRadius: 8, marginBottom: 16 }}>
              <div style={{ fontSize: '0.85rem', color: 'var(--color-text-3)', marginBottom: 4 }}>Registro a eliminar:</div>
              <div style={{ fontWeight: 600 }}>{descripcion}</div>
            </div>
          )}
          
          <div className="form-group">
            <label className="form-label">🔐 Confirma con tu contraseña</label>
            <input type="password" className="form-control" value={password} 
              onChange={e => setPassword(e.target.value)} 
              placeholder="Tu contraseña actual"
              onKeyDown={e => e.key === 'Enter' && password && handleEliminar()} />
          </div>
          
          {error && <div className="alert alert-danger">{error}</div>}
        </div>
        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>Cancelar</button>
          <button className="btn btn-danger" onClick={handleEliminar} disabled={loading || !password}>
            {loading ? <div className="spinner" style={{ width: 16, height: 16 }} /> : <Trash2 size={16} />}
            Eliminar definitivamente
          </button>
        </div>
      </div>
    </div>
  );
}

// ───────────────────────────────────────────────────────────────
// Helper: comprobar si es admin desde el token
// ───────────────────────────────────────────────────────────────
export function esAdmin() {
  try {
    const token = localStorage.getItem('token');
    if (!token) return false;
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.username === 'admin' || payload.rol === 'administrador';
  } catch { return false; }
}
